jQuery(function ($) {
  var duration = 200;
  var easing = "easeOutCubic";

  if (!$.easing.easeOutCubic) {
    $.easing.easeOutCubic = function (x) {
      return 1 - Math.pow(1 - x, 3);
    };
  }

  function setAccordionIconOpen($item, isOpen) {
    $item
      .children(".product-description-accordion-header")
      .find("svg.accordion-icon")
      .toggleClass("accordion-icon--open", isOpen);
  }

  function getAccordionContent($item) {
    return $item.children(".product-description-accordion-content");
  }

  function isAccordionItemOpen($item) {
    return getAccordionContent($item).hasClass("is-open");
  }

  function setAccordionItemOpen($item, isOpen) {
    var $content = getAccordionContent($item);
    if (!$content.length) return;

    if (isAccordionItemOpen($item) === isOpen) {
      setAccordionIconOpen($item, isOpen);
      return;
    }

    $content.toggleClass("is-open", isOpen);
    setAccordionIconOpen($item, isOpen);

    $content.stop(true, false);
    if (isOpen) {
      $content.slideDown(duration, easing);
    } else {
      $content.slideUp(duration, easing);
    }

    if (isOpen && $item.is("[data-see-it-in-action]")) {
      $item[0].dispatchEvent(
        new CustomEvent("see-it-in-action:load", { bubbles: true }),
      );
    }
  }

  function closeOtherAccordionItems($accordion, $activeItem) {
    $accordion.children("li").each(function () {
      var $item = $(this);
      if ($item[0] !== $activeItem[0]) {
        setAccordionItemOpen($item, false);
      }
    });
  }

  $("#product-description-accordion > li").each(function () {
    var $item = $(this);
    var $content = getAccordionContent($item);
    if ($content.css("display") === "block") {
      $content.addClass("is-open");
      setAccordionIconOpen($item, true);
    }
  });

  $(document).on("click", ".product-description-accordion-header", function () {
    var $header = $(this);
    var $accordion = $("#product-description-accordion");
    if (!$accordion.length || !$accordion.has($header).length) return;

    var $item = $header.closest("li");
    if (!$item.length || $item.parent()[0] !== $accordion[0]) return;

    var willOpen = !isAccordionItemOpen($item);

    if (willOpen) {
      closeOtherAccordionItems($accordion, $item);
    }

    setAccordionItemOpen($item, willOpen);
  });

  $(document).on("click", ".size-guide-modal-trigger--dynamic", function (event) {
    event.preventDefault();

    var $accordion = $("#product-description-accordion");
    var $fitGuide = $("#fit-guide");
    if (!$fitGuide.length || !$accordion.length) return;

    var $fitGuideContent = getAccordionContent($fitGuide);
    var $fitGuideHeader = $fitGuide.children(
      ".product-description-accordion-header",
    );
    if (!$fitGuideContent.length || !$fitGuideHeader.length) return;

    if (!isAccordionItemOpen($fitGuide)) {
      closeOtherAccordionItems($accordion, $fitGuide);
      setAccordionItemOpen($fitGuide, true);
    }
  });
});
